// Own visitor tracking, shown in /admin > Analytics. Sends tiny events to /api/track.
// No cookies or personal data: a random id in localStorage tells repeat visits apart.

const TYPES = ['view', 'resume', 'project', 'contact', 'email', 'social', 'chat'];

function store(kind, key, make) {
  try {
    const s = window[kind];
    let v = s.getItem(key);
    if (!v && make) { v = make(); if (v) s.setItem(key, v); }
    return v;
  } catch {
    return make ? make() : null;
  }
}

const visitorId = () => store('localStorage', 'cu_vid', () => Math.random().toString(36).slice(2) + Date.now().toString(36));

// ?r=123 is added to the portfolio link in Job Hunter letters; keep it for the whole visit.
function refCode() {
  const fromUrl = new URLSearchParams(window.location.search).get('r');
  if (fromUrl) store('sessionStorage', 'cu_ref', () => fromUrl.slice(0, 40));
  return store('sessionStorage', 'cu_ref');
}

function referrerHost() {
  try {
    const host = new URL(document.referrer).hostname.replace(/^www\./, '');
    return host && host !== window.location.hostname.replace(/^www\./, '') ? host : '';
  } catch {
    return '';
  }
}

export function track(type, label) {
  if (!TYPES.includes(type) || window.location.pathname.startsWith('/admin')) return;
  if (/bot|crawl|spider|lighthouse|headless/i.test(navigator.userAgent)) return;
  const body = JSON.stringify({
    type,
    label: label || null,
    path: window.location.pathname,
    ref: refCode(),
    referrer: type === 'view' ? referrerHost() : '',
    device: /Mobi|Android|iPhone/i.test(navigator.userAgent) ? 'mobile' : 'desktop',
    visitor: visitorId(),
  });
  try {
    if (!navigator.sendBeacon || !navigator.sendBeacon('/api/track', body)) {
      fetch('/api/track', { method: 'POST', body, keepalive: true }).catch(() => {});
    }
  } catch {
    // tracking must never break the page
  }
}

// One question + answer from the site chat, saved to that chat's conversation (read in /admin > Chat answers).
export function logChat(session, question, answer, unanswered) {
  if (window.location.pathname.startsWith('/admin') || /bot|crawl|spider|lighthouse|headless/i.test(navigator.userAgent)) return;
  const body = JSON.stringify({
    session, question, answer, unanswered: !!unanswered, path: window.location.pathname,
    device: /Mobi|Android|iPhone/i.test(navigator.userAgent) ? 'mobile' : 'desktop', visitor: visitorId(),
  });
  try {
    if (!navigator.sendBeacon || !navigator.sendBeacon('/api/chat-log', body)) {
      fetch('/api/chat-log', { method: 'POST', body, keepalive: true }).catch(() => {});
    }
  } catch {
    // logging must never break the chat
  }
}
